import { defaultReturn } from '../../../util/newStudent';
import * as api from '../../api/newStudent/apiStudent.service';

export type EvaluativeCalendarEvent = {
  id: string;
  date: string;
  title: string;
  kind: 'start' | 'end';
  disciplineName: string;
  courseName: string;
  registrationId: number;
};

export type EvaluativeCalendarCourseOption = { id: number; courseName: string };

/** Calendário avaliativo (API em `student/calendar`, não em my-grades). */
export const calendarServiceNewStudent = {
  async evaluativeCalendar(courseId?: number): Promise<{
    data: { events: EvaluativeCalendarEvent[]; courses: EvaluativeCalendarCourseOption[] };
    message: string[];
    result: boolean;
  }> {
    const q =
      courseId != null && courseId !== 0
        ? `?courseId=${encodeURIComponent(String(courseId))}`
        : '';
    const request = await api.authenticatedRequest(
      `/student/calendar/evaluative-calendar${q}`,
      'GET',
    );
    return defaultReturn(request);
  },
};
